module.exports = __webpack_public_path__ + "static/media/people.5daed046.svg";